var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',{attrs:{"code":"403","title":"errors.403_title","message":"errors.403_message"}})
}
var staticRenderFns = []

export { render, staticRenderFns }